/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * describes the status of an order
 * @export
 */
export const OrderStatus = {
    Open: 'OPEN',
    Fulfilled: 'FULFILLED',
    Cancelled: 'CANCELLED',
    Prorated: 'PRORATED'
} as const;
export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


export function OrderStatusFromJSON(json: any): OrderStatus {
    return OrderStatusFromJSONTyped(json, false);
}

export function OrderStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderStatus {
    return json as OrderStatus;
}

export function OrderStatusToJSON(value?: OrderStatus | null): any {
    return value as any;
}

